module.exports = {
        srcSet: __webpack_public_path__ + "7cc38bf305e06931-600.webp"+" 600w"+","+__webpack_public_path__ + "b0805656c7503712-1000.webp"+" 1000w",
        images: [{path: __webpack_public_path__ + "7cc38bf305e06931-600.webp",width: 600,height: 338},{path: __webpack_public_path__ + "b0805656c7503712-1000.webp",width: 1000,height: 563}],
        src: __webpack_public_path__ + "b0805656c7503712-1000.webp",
        toString: function(){return __webpack_public_path__ + "b0805656c7503712-1000.webp"},
        
        width: 1000,
        height: 563
      }